package com.trevorwiebe.timesheet.mileage.presentation

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.graphics.ImageBitmap
import com.trevorwiebe.timesheet.core.presentation.common.toImageBitmap
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.withContext
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp

@Composable
fun ReceiptButtonSection(
    uiState: MileageUiState,
    onEvent: (MileageEvent) -> Unit
) {
    val launchPicker = rememberImagePickerLauncher { pages ->
        onEvent(MileageEvent.OnReceiptImageSelected(pages.first()))
    }

    val bytes = uiState.pendingReceiptBytes?.bytes
    var imageBitmap by remember { mutableStateOf<ImageBitmap?>(null) }
    LaunchedEffect(bytes) {
        imageBitmap = if (bytes != null) {
            withContext(Dispatchers.Default) { bytes.toImageBitmap() }
        } else null
    }

    val thumbnailShape = RoundedCornerShape(8.dp)

    Row(
        modifier = Modifier.fillMaxWidth().height(IntrinsicSize.Min),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(8.dp)
    ) {
        Box(
            modifier = Modifier.weight(1f).fillMaxHeight(),
            contentAlignment = Alignment.Center
        ) {
            val bitmap = imageBitmap
            if (bitmap != null) {
                Image(
                    bitmap = bitmap,
                    contentDescription = "Receipt thumbnail — tap to view",
                    modifier = Modifier
                        .height(100.dp)
                        .aspectRatio(1f)
                        .clip(thumbnailShape)
                        .clickable(enabled = !uiState.isLoadingReceiptImage) {
                            onEvent(MileageEvent.OnShowPhotoViewer)
                        },
                    contentScale = ContentScale.Crop
                )
            } else {
                Box(
                    modifier = Modifier
                        .height(100.dp)
                        .aspectRatio(1f)
                        .clip(thumbnailShape)
                        .background(MaterialTheme.colorScheme.surfaceVariant)
                )
            }
            if (uiState.isLoadingReceiptImage) {
                CircularProgressIndicator(
                    color = MaterialTheme.colorScheme.tertiary,
                    modifier = Modifier.size(32.dp)
                )
            }
        }

        if (!uiState.isEditingLocked) {
            OutlinedButton(
                onClick = { launchPicker() },
                enabled = !uiState.isExtractingReceipt && !uiState.isLoadingReceiptImage,
                modifier = Modifier.weight(2f)
            ) {
                Text(
                    when {
                        uiState.isExtractingReceipt -> "Reading receipt..."
                        uiState.pendingReceiptBytes != null -> "Receipt Added"
                        else -> "Add Receipt Photo"
                    }
                )
            }
        }
    }
}
